import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { ProfileProvider } from './lib/profile.js';
import { SessionProvider, useSession } from './lib/session.js';
import { BookingDetailScreen, Bookings } from './screens/Bookings.js';
import { Layout } from './screens/Layout.js';
import { Admin, AdminDriverScreen } from './screens/Admin.js';
import { AvailabilitySettings } from './screens/Availability.js';
import { Calculator } from './screens/Calculator.js';
import { NotificationsSettings } from './screens/Notifications.js';
import { People } from './screens/People.js';
import { PassengerScreen } from './screens/Passengers.js';
import { Reminders } from './screens/Reminders.js';
import { LogTrip } from './screens/LogTrip.js';
import { Services } from './screens/Services.js';
import {
  BillingSettings,
  PaymentsSettings,
  ProfileSettings,
  RulesSettings,
  Settings,
  ShareSettings,
  VehicleSettings,
} from './screens/Settings.js';
import { SignIn } from './screens/SignIn.js';
import { Today } from './screens/Today.js';
import { ReferralScreen } from './screens/Referral.js';
import { Updates } from './screens/Updates.js';

/** Links from before messages moved into People, such as older notifications, open the conversation there. */
function OldConversationLink() {
  const { id = '' } = useParams();
  return <Navigate to={`/people?chat=${encodeURIComponent(id)}`} replace />;
}

function Gate() {
  const { ready, session } = useSession();
  if (!ready) return <div className="p-6 text-muted">Loading…</div>;
  if (!session) return <SignIn />;
  return (
    <ProfileProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Today />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/bookings/availability" element={<AvailabilitySettings />} />
          <Route path="/bookings/:id" element={<BookingDetailScreen />} />
          <Route path="/log" element={<LogTrip />} />
          <Route path="/messages" element={<Navigate to="/people" replace />} />
          <Route path="/messages/:id" element={<OldConversationLink />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/referrals/:id" element={<ReferralScreen />} />
          <Route path="/people" element={<People />} />
          <Route path="/people/passengers/:id" element={<PassengerScreen />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/services" element={<Services />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/profile" element={<ProfileSettings />} />
          <Route path="/settings/vehicle" element={<VehicleSettings />} />
          <Route path="/settings/rules" element={<RulesSettings />} />
          <Route path="/settings/availability" element={<Navigate to="/bookings/availability" replace />} />
          <Route path="/settings/notifications" element={<NotificationsSettings />} />
          <Route path="/settings/payments" element={<PaymentsSettings />} />
          <Route path="/settings/billing" element={<BillingSettings />} />
          <Route path="/settings/share" element={<ShareSettings />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/drivers/:id" element={<AdminDriverScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ProfileProvider>
  );
}

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Gate />
      </BrowserRouter>
    </SessionProvider>
  );
}
